import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const MultipleChoiceSingleIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M9.3999 4.04999H14.9999"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="3.9" cy="4.15" r="2.9" stroke="currentColor" />
    <path
      d="M9.3999 12.45H14.9999"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 12.75L3 14.75L7 9.75"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
